<template>

<div class="appWrapper">
    <div class="holder">
        <div class="thankyouWrapper">
            <h3>Page Not Found</h3>
            <p>Sorry, that page does not exist.</p>
        </div>
    </div>
</div>


</template>

